import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';

class TermPlanApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async Get(id: number) {
        const { data } = await this.httpClient.get(`/term-plans/${id}`)
        return data;
    }

    async GetAll() {
        const { data } = await this.httpClient.get('/term-plans');
        return data;
    }

    //TODO: update weekDay => weekday
    async Generate(termCampusId: number, weekDayId: number, type: string) {
        const postObj = {
            termCampusId,
            weekDayId,
            type,
        };

        const { data } = await this.httpClient.post('/term-plans', postObj);
        return data;
    }

    async GetStatuses() {
        const { data } = await this.httpClient.get("/term-plan-items/statuses");
        return data;
    }

    async SavePlan(termPlan: any) {
        const { data } = await this.httpClient.put(`/term-plans`, termPlan)
        return data;
    }
}

export default TermPlanApi;
